module.exports = __webpack_public_path__ + "static/media/Primate-House3.40166a8f.jpg";